<template>
  <form
    id="login"
    ref="loginForm"
    :action="formAction"
    method="GET"
  >
    <sidepage
      v-if="ssoButton"
      :show-quotes="false"
    />
    <div id="login-contents">
      <div
        id="login-body"
        class="body"
      >
        <div
          v-if="showWarning"
          id="sso-login-failure-warning"
          class="warning fs-unmask"
        >
          <p class="font-weight-bold">
            {{ $t('login.sso.warning.header') }}
          </p>
          <p>
            {{ $t('login.sso.warning.description') }}
          </p>
        </div>
        <user-name-login
          :user-name="username"
          @update-user-name-login="setUserName"
        />
        <tc-v-btn
          id="sso-login-submit-button"
          class="btn-primary w-100"
          :disabled="!canSubmit"
          @click="loginIfReady"
        >
          {{ $t('login.form.button') }}
        </tc-v-btn>
        <hr>
        <tc-v-btn
          v-if="ssoButton"
          id="login-different-method-button"
          class="btn-secondary w-100"
          exact
          @click="$router.push({ name: 'Login' })"
        >
          {{ $t('login.sso.loginDifferentMethod') }}
        </tc-v-btn>
      </div>
    </div>

    <input
      id="success-uri"
      name="successUri"
      type="hidden"
      :value="successRedirectMFA"
    >
    <input
      id="failure-uri"
      name="failureUri"
      type="hidden"
      :value="samlFailureRedirect"
    >
  </form>
</template>

<script>
import SidePage from '@/components/shared/SidePage'
import { LoginMixin } from '../shared/mixins/LoginMixin'
import UserNameLogin from './UserNameLogin'

export default {
  name: 'SSOLogin',
  components: {
    sidepage: SidePage,
    UserNameLogin
  },
  mixins: [LoginMixin],
  props: {
    defaultUserName: {
      type: String,
      required: true
    },
    ssoButton: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      username: this.defaultUserName
    }
  },
  computed: {
    canSubmit () {
      return !this.errors.items.length && this.username
    },
    samlFailureRedirect () {
      return `${this.redirectHost}/#/login/SSO?error=true`
    },
    formAction () {
      return `${this.rgfeApiHost}/saml/discovery`
    },
    showWarning () {
      return this.$route.query.error
    }
  },
  methods: {
    async loginIfReady () {
      if (this.canSubmit) {
        this.$refs.loginForm.submit()
      }
    },
    setUserName (username) {
      this.username = username
    }
  }
}
</script>

<style scoped lang="scss">
  @import 'Login';

  p {
    margin: 0;
  }

  .warning {
    padding: 5px;
    background: #fef8f0;
    border: 1px solid #fae0b5;
    margin-bottom: 10px;
  }

</style>
